import { render, staticRenderFns } from "./UnitBind.vue?vue&type=template&id=fff88926&scoped=true"
import script from "./UnitBind.vue?vue&type=script&lang=js"
export * from "./UnitBind.vue?vue&type=script&lang=js"
import style0 from "./UnitBind.vue?vue&type=style&index=0&id=fff88926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff88926",
  null
  
)

export default component.exports